import { motion } from "framer-motion";
import type { ClarificationQuestion } from "@/lib/decisionEngine";

interface Props {
  questions: ClarificationQuestion[];
  onAnswer: (questionId: string, answer: string) => void;
  answeredCount: number;
}

export default function ClarificationStep({ questions, onAnswer, answeredCount }: Props) {
  const current = questions[answeredCount];
  if (!current) return null;

  return (
    <motion.div
      key={current.id}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="w-full max-w-lg mx-auto text-center"
    >
      <p className="text-muted-foreground text-sm mb-2 font-body">Quick question {answeredCount + 1} of {questions.length}</p>
      <h3 className="text-xl font-display font-semibold text-foreground mb-6">{current.question}</h3>
      <div className="flex flex-wrap justify-center gap-3">
        {current.options.map((opt) => (
          <motion.button
            key={opt}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => onAnswer(current.id, opt)}
            className="px-6 py-3 rounded-xl border border-border bg-secondary text-secondary-foreground font-medium font-body hover:border-primary/40 hover:bg-primary/5 transition-all duration-200"
          >
            {opt}
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
}
